import { render, staticRenderFns } from "./tableRuleForm.vue?vue&type=template&id=63a76979&"
import script from "./tableRuleForm.vue?vue&type=script&lang=js&"
export * from "./tableRuleForm.vue?vue&type=script&lang=js&"
import style0 from "./tableRuleForm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports